import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DataFilter, DataService } from '../../services/data.service';
import { ConfigProfileRoleActionsExtended, ConfigService } from '../../services/config.service';
import { Subscription } from 'rxjs';
import { LocalizationService } from '../../services/localization.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PGTask, PGTaskAction, TasksService } from '../../services/tasks.service';
import { ConnectorType } from '../../services/environment.service';
import { AuthService } from '../../services/auth.service';

class PgMassPublishModalComponentElement { 
    id: string
    label: string 
    disabled?:boolean 
}

@Component({
    selector: 'app-pg-mass-publish-modal',
    templateUrl: './pg-mass-publish-modal.component.html',
    styleUrl: './pg-mass-publish-modal.component.scss',
    standalone: false
})
export class PgMassPublishModalComponent implements OnInit, OnDestroy {

    constructor(private activeModal:NgbActiveModal, private dataService:DataService, private configService:ConfigService, private localizationService:LocalizationService, private taskService:TasksService, private authService:AuthService) {}

    @Input() resourceId:string;

    actions:ConfigProfileRoleActionsExtended = null;

    publishOnOptions:Array<{ value:string, text:string }> = null;
    publishOnValue:ConnectorType|'entourance' = null;

    ngOnInit(): void {
        this.actions = this.configService.getResourceActionsExtended(this.resourceId)

        if(this.actions.publish) {
            this.publishOnValue = 'entourance'
            this.publishOnOptions = []
            this.publishOnOptions.push({ value: 'entourance', text: 'Entourance' })
            
            for(let _connector of ['TDH','DHM']) {
                if(this.dataService.canPublishOn(_connector as any, this.resourceId, this.authService.user.realm.id)) {
                    this.publishOnOptions.push({ value: _connector, text: _connector })
                }
            }
        }

        this.onPublishOnValueChange()
    }

    ngOnDestroy(): void {
        if(this._loadResourceSubscription != null) this._loadResourceSubscription.unsubscribe()
    }

    resourceData:Array<PgMassPublishModalComponentElement> = null

    pageSize = 10;
    pageNum = -1;

    isLoadingResource = false;

    private _loadResourceSubscription:Subscription = null;

    onPublishOnValueChange() {
        if(this._loadResourceSubscription != null) this._loadResourceSubscription.unsubscribe()

        this.resourceData = []
        this.pageNum = 0;
        this.isLoadingResource = false;

        this.loadResource()
    }

    loadResource() {
        let _publishOn = this.publishOnValue;

        if(_publishOn != null) {
            this.isLoadingResource = true;
    
            let _filter:Array<DataFilter> = []
    
            if(_publishOn == 'entourance') {
                _filter = [{ field: 'published', operator: '!=', value: [true] }]
            }
            else {
                _filter = [{ field: 'published', operator: '==', value: [true] }]
            }
    
            this._loadResourceSubscription = this.dataService.getResourceData(this.resourceId, { limit: this.pageSize + 1, offset: this.pageNum * this.pageSize, filter: _filter }).subscribe((data) => {
                for(let i = 0; i < this.pageSize; i++) {
                    if(data[i] != null) {
                        let _label = null;
    
                        if(data[i].translations) {
                            for(let _item of data[i].translations) {
                                if(_item.language == this.localizationService.currentLanguage) {
                                    _label = _item.name || _item.title;
                                    break;
                                }
                            }
                        }
                        
                        if(_label == null) {
                            _label = data[i].name || data[i].title;
                        }
    
                        let _disabled = false;
    
                        if(_publishOn == 'entourance') {
                            _disabled = this.resourceId.replace(/~.*$/, '') == 'Experience' && data[i].supplier == null
                        }
                        else {
                            _disabled = !this.dataService.canPublishOn(_publishOn as any, this.resourceId, this.authService.user.realm.id)
                        }
    
                        this.resourceData.push({ 
                            id: data[i].id, 
                            label: _label,
                            disabled: _disabled
                        })
                    }
                }
    
                if(data.length > this.pageSize) {
                    this.pageNum++;
                    this.loadResource()
                }
                else {
                    this.isLoadingResource = false;
                    if(this.isClosing) {
                        this.doMassPublish();
                    }
                }
            })
        }
    }

    // NB: questa gestione un po' incasinata è perché potrei avere alcuni elementi non caricati che dovrebbero essere considerati selezionati o non selezionati in base a come sta selectAll
    // vado quindi a segnare solo quelli che interagisce l'utente

    selectAll = true;
    elementToggleIndex:{ [id:string]: boolean } = {}

    onSelectAllChange() {
        this.elementToggleIndex = {};
    }

    isElementSelected(element:PgMassPublishModalComponentElement) {
        if(element.disabled) return false;
        else if(this.elementToggleIndex[element.id] != null) return this.elementToggleIndex[element.id];
        else return this.selectAll
    }

    setElementSelected(element:PgMassPublishModalComponentElement, value:boolean) {
        if(!element.disabled) {
            this.elementToggleIndex[element.id] = value;
        }
    }
    

    dismissModal() {
        this.activeModal.dismiss()
    }

    isClosing = false;

    doMassPublish() {
        this.isClosing = true;

        if(!this.isLoadingResource) {
            let _list = [];

            for(let _item of this.resourceData) {
                if(this.isElementSelected(_item)) _list.push(_item.id)
            }

            if(_list.length > 0) {
                let _completed = 0;
                let _failed = []
    
                let _publishNextRec:PGTaskAction = (resolve, reject, progress) => {
                    let _item = _list[_completed]
    
                    let _whenDone = () => {
                        _completed++
                        let _progress = _completed / _list.length
                        progress(_progress)
    
                        if(_progress == 1) {
                            if(_failed.length == 0) {
                                resolve()
                            }
                            else {
                                reject(false, this.localizationService.translate('pg-mass-publish-modal.task-some-failed', { failed: _failed.join(', ') }))
                            }
                        }
                        else {
                            _publishNextRec(resolve, reject, progress)
                        }
                    }
    
                    if(this.publishOnValue == 'entourance') {
                        this.dataService.putElementData(this.resourceId, _item, { published: true }).subscribe((data) => {
                            _whenDone()
                        }, () => {
                            _failed.push(_item)
                            _whenDone()
                        })
                    }
                    else {
                        this.dataService.doPublishOn(this.publishOnValue, this.resourceId, _item, this.authService.user.realm.id).subscribe((data) => {
                            _whenDone()
                        }, () => {
                            _failed.push(_item)
                            _whenDone()
                        })
                    }
                }
    
                this.taskService.addTask(new PGTask(_publishNextRec, this.localizationService.translate('pg-mass-publish-modal.task-name', { on: this.publishOnValue.toUpperCase(), list: _list.join(', ') })))
            }

            this.activeModal.close()
        }
    }
}
